import { render, staticRenderFns } from "./LcaProductFamilyDetail.vue?vue&type=template&id=ebd46e30&scoped=true"
import script from "./LcaProductFamilyDetail.vue?vue&type=script&lang=js"
export * from "./LcaProductFamilyDetail.vue?vue&type=script&lang=js"
import style0 from "./LcaProductFamilyDetail.vue?vue&type=style&index=0&id=ebd46e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd46e30",
  null
  
)

export default component.exports